<!--  -->
<template>
  <div class='UserBody maxWidth'>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>商家信息设置</span>
      </div>
      <div>
        <el-form v-loading="loading" element-loading-text="正在上传..." label-width="130px" :model="form" ref="form" :rules="rules">
          <div class="userMsg">
            <div>
              <el-form-item label="公司名称" prop="companyName">
                <el-input v-model="form.companyName" placeholder="请输入公司名称"></el-input>
              </el-form-item>
              <el-form-item label="联系人" prop="contactsPerson">
                <el-input v-model="form.contactsPerson" placeholder="请输入联系人姓名" maxlength="12"></el-input>
              </el-form-item>
              <el-form-item label="营业执照：" prop="businessPic">
                <div class="videoParent">
                  <el-upload action="" v-if="!form.businessPic" :show-file-list="false" :http-request="uploadImg" multiple :accept="accept">
                    <img src="@/assets/upload.png" @click="changeName('businessPic')" class="img" alt="">
                  </el-upload>
                  <div class="relativeDiv" v-else>
                    <img src="@/assets/del.png" class="del" @click="delImg('businessPic')" alt="">
                    <el-image :src="form.businessPic" class="img" :preview-src-list="[form.businessPic]" ></el-image>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="第二类医疗器械经营备案：" prop="managePic">
                <div class="videoParent">
                  <el-upload action="" v-if="!form.managePic" :show-file-list="false" :http-request="uploadImg" multiple :accept="accept">
                    <img src="@/assets/upload.png" @click="changeName('managePic')" class="img" alt="">
                  </el-upload>
                  <div class="relativeDiv" v-else>
                    <img src="@/assets/del.png" class="del" @click="delImg('managePic')" alt="">
                    <el-image :src="form.managePic" class="img" :preview-src-list="[form.managePic]" ></el-image>
                  </div>
                </div>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="职位" prop="position">
                <el-input v-model="form.position" placeholder="请输入职位" maxlength="20"></el-input>
              </el-form-item>
              <el-form-item style="margin-top: 80px" label="第二类医疗器械生产备案：" prop="productionPic">
                <div class="videoParent">
                  <el-upload action="" v-if="!form.productionPic" :show-file-list="false" :http-request="uploadImg" multiple :accept="accept">
                    <img src="@/assets/upload.png" @click="changeName('productionPic')" class="img" alt="">
                  </el-upload>
                  <div class="relativeDiv" v-else>
                    <img src="@/assets/del.png" class="del" @click="delImg('productionPic')" alt="">
                    <el-image :src="form.productionPic" class="img" :preview-src-list="[form.productionPic]" ></el-image>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="第二类医疗器械产品备案：" prop="productPic">
                <div class="videoParent">
                  <el-upload action="" v-if="!form.productPic" :show-file-list="false" :http-request="uploadImg" multiple :accept="accept">
                    <img src="@/assets/upload.png" @click="changeName('productPic')" class="img" alt="">
                  </el-upload>
                  <div class="relativeDiv" v-else>
                    <img src="@/assets/del.png" class="del" @click="delImg('productPic')" alt="">
                    <el-image :src="form.productPic" class="img" :preview-src-list="[form.productPic]" ></el-image>
                  </div>
                </div>
              </el-form-item>
            </div>
          </div>
          
          <el-form-item label="补充资料：">
            <div class="videoParent">
              <div class="fileList">
                <div class="relativeDiv" v-for="(item, i) in form.supplyLinks" :key="item">
                  <img src="@/assets/del.png" class="del" @click="delImgList(i)" alt="">
                  <el-image v-if="checkImg(item)" :src="item" class="img" fit="contain" :preview-src-list="form.supplyLinks" ></el-image>
                  <div class="img" v-else>
                    <a :href="item" target="_blank">
                      <div>文件</div>
                      <div class="smallFont">（点击查看）</div>
                    </a>
                  </div>
                </div>
                <el-upload action="" list-type="picture-card" :show-file-list="false" :http-request="uploadImgList" multiple>
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>
            </div>
          </el-form-item>
        </el-form>

        <div style="margin-top: 20px">
          <el-button type="primary" size="medium" @click="doSave">提交审核</el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { checkImg } from "@/utils/utils";
export default {
  components: {},
  data() {
    return {
      form: {},
      loading: false,
      accept: '.jpg, .jpeg, .png',
      rules: {
        companyName: [{ required: true, message: '请输入公司名称', trigger: 'blur' },],
        contactsPerson: [{ required: true, message: '请输入联系人姓名', trigger: 'blur' },],
        // phone: [{ required: true, message: '请输入手机号', trigger: 'blur' },],
        // code: [{ required: true, message: '请输入验证码', trigger: 'blur' },],
        // pwd: [{ required: true, message: '请输入密码', trigger: 'blur' },],
        // repwd: [{ validator: validatePwd, trigger: 'blur' },],
        position: [{ required: true, message: '请输入职位', trigger: 'blur' },],
        businessPic: [{ required: true, message: '请上传营业执照', trigger: 'blur' },],
        managePic: [{ required: true, message: '请上传第二类医疗器械经营备案', trigger: 'blur' },],
        productionPic: [{ required: true, message: '请上传第二类医疗器械生产备案', trigger: 'blur' },],
        productPic: [{ required: true, message: '请上传第二类医疗器械产品备案', trigger: 'blur' },],
      },
    }
  },
  computed: {},
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
  
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getData()
  },
  methods: {
    doSave() {
      this.$refs.form.validate(val => {
        if(!val)return
        this.$http.post('/api/WebUser/ModifyUser', this.form).then(() => {
          this.$message.success('修改成功')
          this.$router.replace({name: 'index'})
        }).catch(() => {})
      })
    },
    checkImg,
    uploadImg(e) {
      this.loading = true
      let params = new FormData()
      params.append('file', e.file)
      this.$http.post('/api/WebUser/UploadFile', params).then(res => {
        this.form[this.name] = res.data.webUrl
      }).finally(() => {
        this.loading = false
      })
    },
    changeName(name) {
      this.name = name
    },
    delImg(name) {
      this.form[name] = ''
    },
    delImgList(i) {
      this.form.supplyLinks.splice(i, 1)
    },
    uploadImgList(e) {
      this.loading = true
      let params = new FormData()
      params.append('file', e.file)
      this.$http.post('/api/WebUser/UploadFile', params).then(res => {
        this.form.supplyLinks.push(res.data.webUrl)
      }).finally(() => {
        this.loading = false
      })
    },
    getData() {
      this.$http.get('/api/WebUser/QueryUserDetail').then(res => {
        this.form = res.data
      })
    }
  },
}
</script>
<style lang='scss'>
.UserBody {
  .el-upload--picture-card {
    width: 110px;
    height: 110px;
    line-height: 110px;
  }
  margin: 24px auto;
  .userMsg {
    display: flex;
    > div {
      flex: 1;
    }
  }

  input {
    width: 450px;
  }
  .img {
    width: 110px;
    height: 110px;
    border-radius: 4px;
  }
  .relativeDiv {
    position: relative;
    width: 110px;
    .del {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 10;
      width: 25px;
      cursor: pointer;
    }
  }
}
.fileList {
    display: flex;
    flex-wrap: wrap;
  }
  .relativeDiv {
    position: relative;
    width: 110px;
    margin-right: 10px;
    margin-bottom: 10px;
    a {
      text-decoration: none;
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 110px;
      line-height: 30px;
    }
    .del {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 10;
      width: 25px;
      cursor: pointer;
    }
  }
</style>